import React from "react";
import { Plus, Trash2 } from "lucide-react";
import { fmtRM0 } from "../../lib/taxConfig";

// Editable list of {label, amount} rows with add / remove
const EditableRows = ({ title, accent, rows, onChange, total }) => {
  const update = (idx, field, value) => {
    const next = rows.map((r, i) => (i === idx ? { ...r, [field]: value } : r));
    onChange(next);
  };
  const remove = (idx) => onChange(rows.filter((_, i) => i !== idx));
  const add = () => onChange([...rows, { label: "", amount: 0 }]);

  return (
    <div className="border border-gray-200 rounded-sm overflow-hidden">
      <div
        className={`px-3 py-2 text-xs font-semibold uppercase tracking-wide ${accent}`}
      >
        {title}
      </div>
      {rows.map((r, idx) => (
        <div key={idx} className="flex items-center gap-2 px-3 py-1.5 border-b border-gray-100">
          <input
            value={r.label}
            onChange={(e) => update(idx, "label", e.target.value)}
            placeholder="Description"
            className="flex-1 text-sm px-2 py-1 border border-transparent hover:border-gray-200 focus:border-[#1877c9] rounded outline-none"
          />
          <input
            type="number"
            value={r.amount}
            onChange={(e) => update(idx, "amount", e.target.value)}
            className="w-36 text-right text-sm font-mono px-2 py-1 border border-gray-200 focus:border-[#1877c9] rounded outline-none"
          />
          <button
            onClick={() => remove(idx)}
            className="p-1.5 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded"
            title="Remove"
          >
            <Trash2 size={15} />
          </button>
        </div>
      ))}
      <div className="flex items-center justify-between px-3 py-2 bg-[#f7f9fc]">
        <button
          onClick={add}
          className="flex items-center gap-1 text-sm text-[#1877c9] hover:underline"
        >
          <Plus size={15} /> Add row
        </button>
        <div className="text-sm font-semibold font-mono text-gray-800">
          {fmtRM0(total)}
        </div>
      </div>
    </div>
  );
};

export default EditableRows;
